import React from "react"
import { concatStrings } from "../utilities"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbParagraph from "../ui-kit/dfb_paragraph"

const CStatusParagraph = ({ paragraph, status, add_class }) => {
  const baseClass = "c-StatusParagraph"
  const icon =
    status === "success"
      ? "check-circle"
      : status === "error"
      ? "delete-circle"
      : null

  return (
    <div
      className={concatStrings(baseClass, `${baseClass}--${status}`, add_class)}
    >
      <DfbParagraph text={paragraph} add_class={`${baseClass}-paragraph`} />
      {icon && <DfbIcon icon_type={icon} add_class={`${baseClass}-icon`} />}
    </div>
  )
}

export default CStatusParagraph
